<button
  mat-button
  class="celo-primary-button uppercase"
  (click)="this.handleSubmit()"
  [disabled]="isDisabled"
>
  {{ text }}
</button>
